import { AntragMetaData } from '@eBeihilfe/einreichung-shared/model';
import { Application } from '../models';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const applicationsUpdateActions = createActionGroup({
  source: 'Einreichung - Applications update',
  events: {
    'Update': props<{ application: Application; metadata: AntragMetaData }>(),
    'Update success': props<{ metadata: AntragMetaData; concurrency: Date }>(), // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'Update failed': props<{ error: any }>(),
    'Clear store': emptyProps(),
  },
});
